import { render, staticRenderFns } from "./RoleCategoriesComponent.vue?vue&type=template&id=38c47528"
import script from "./RoleCategoriesComponent.vue?vue&type=script&lang=js"
export * from "./RoleCategoriesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports